// Display translations for fabrication step names.
// Step names are STORED in French (canonical); this maps known names for display.
// Unknown / custom names (including EBC steps typed in Russian) are shown as-is.

const STEP_TRANSLATIONS = {
  'découpe de la piscine': { ru: 'Резка бассейна', md: 'Debitarea piscinei', uk: 'Різання басейну' },
  'structure de la piscine': { ru: 'Каркас бассейна', md: 'Structura piscinei', uk: 'Каркас басейну' },
  'peinture': { ru: 'Покраска', md: 'Vopsire', uk: 'Фарбування' },
  'pose de plaques pvc': { ru: 'Монтаж ПВХ-панелей', md: 'Montarea plăcilor PVC', uk: 'Монтаж ПВХ-панелей' },
  'pose des accessoires': { ru: 'Установка аксессуаров', md: 'Montarea accesoriilor', uk: 'Встановлення аксесуарів' },
  "pose de l'étanchéité": { ru: 'Монтаж гидроизоляции', md: 'Montarea hidroizolației', uk: 'Монтаж гідроізоляції' },
  'réalisation du local technique': { ru: 'Изготовление технического помещения', md: 'Realizarea camerei tehnice', uk: 'Виготовлення технічного приміщення' },
  'test et préparation pour la livraison': { ru: 'Тестирование и подготовка к доставке', md: 'Testare și pregătire pentru livrare', uk: 'Тестування та підготовка до доставки' },
  'electricite': { ru: 'Электрика', md: 'Electricitate', uk: 'Електрика' },
  'électricité': { ru: 'Электрика', md: 'Electricitate', uk: 'Електрика' },
  'pompe à chaleur': { ru: 'Тепловой насос', md: 'Pompă de căldură', uk: 'Тепловий насос' },
  'volet': { ru: 'Роллеты', md: 'Rulou', uk: 'Ролети' },
  'volet immergé': { ru: 'Подводные роллеты', md: 'Rulou imersat', uk: 'Підводні ролети' },
  'pose du volet roulant immergé': { ru: 'Монтаж подводных роллет', md: 'Montarea ruloului imersat', uk: 'Монтаж підводних ролет' },
  'volet roulant immergé aquafermetures': { ru: 'Подводные роллеты Aquafermetures', md: 'Rulou imersat Aquafermetures', uk: 'Підводні ролети Aquafermetures' },
  "raccorder l'eau et l'évacuation": { ru: 'Подключить воду и слив', md: 'Racordarea apei și a evacuării', uk: 'Підключити воду та злив' },
  'pose du chevron': { ru: 'Монтаж деревянных брусьев', md: 'Montarea căpriorilor', uk: "Монтаж дерев'яних брусів" },
  'finir les graviers': { ru: 'Закончить гравий', md: 'Finalizarea pietrișului', uk: 'Закінчити гравій' },
  'ravalement': { ru: 'Отделка фасада', md: 'Renovarea fațadei', uk: 'Оздоблення фасаду' },
};

export function translateStepName(name, language) {
  if (!name || language === 'fr') return name;
  const key = name.trim().toLowerCase().replace(/’/g, "'");
  const tr = STEP_TRANSLATIONS[key];
  return (tr && tr[language]) || name;
}
